import { useEffect } from 'react';

import { useTalkingPointsViewsActions } from 'src/store';
import { useNewestLastExtractionDate } from './useNewestLastExtractionDate';

export const useRefreshTalkingPointsViews = () => {
  const talkingPointsViewsActions = useTalkingPointsViewsActions();
  const newestLastExtractionDate = useNewestLastExtractionDate();

  useEffect(() => {
    talkingPointsViewsActions.refreshTalkingPointsViewList();
  }, [talkingPointsViewsActions, newestLastExtractionDate]);
};
